/* eslint-disable no-nested-ternary */
import { i18n } from 'i18next';
import screens from 'constants/screens';
import MenuDots from 'modules/_shared/components/MenuDots';
import CellData from 'modules/_shared/components/Tables/CellData';

import societyOptions from '../constants/administratedListMenuOptions';
import { AdministratedListItem } from '../types/AdministratedList';

type Row = AdministratedListItem;

const tableColumns = (i18n: i18n) => [
  {
    // mandatory props
    name: i18n.t('Society'),
    field: 'name',
    selector: (row: Row) => row[i18n.t('Society') as keyof Row],
    sortable: true,
    // optional props
    grow: 4,
    cell: (row: Row) =>
      CellData.Society({
        society: row.society,
        url: '/sociedad',
        type: 'light',
        transactionRef: null,
        userRoles: null,
        customLink: null,
        noRedirect: false,
        showHolding: false,
      }),
    export: true,
  },
  {
    name: i18n.t('Partners'),
    field: 'partners',
    selector: (row: Row) => row[i18n.t('Partners') as keyof Row],
    sortable: true,
    center: true,
    compact: true,
    hide: screens.SM,
    cell: (row: Row) =>
      CellData.SocietyPartners({
        partners: row[i18n.t('Partners') as keyof Row],
        isAdmin: true,
        society: row.society,
      }),
    export: true,
  },
  {
    name: i18n.t('Value'),
    field: 'value',
    selector: (row: Row) => row[i18n.t('Value') as keyof Row],
    sortable: true,
    center: true,
    grow: 2,
    compact: true,
    hide: screens.MD,
    cell: (row: Row) =>
      CellData.SocietyValue({
        value: row[i18n.t('Value') as keyof Row],
      }),
    export: true,
  },
  {
    name: i18n.t('ConstDate'),
    field: 'creationDate',
    selector: (row: Row) => row[i18n.t('ConstDate') as keyof Row],
    sortable: true,
    compact: true,
    center: true,
    hide: screens.LG,
    cell: (row: Row) =>
      CellData.PlainDate({
        date: row[i18n.t('ConstDate') as keyof Row],
        monthYear: true,
      }),
    export: true,
  },
  // TODO* this column looks like it's not being used
  {
    name: i18n.t('LastModification'),
    field: '',
    selector: (row: Row) => row[i18n.t('LastModification') as keyof Row],
    sortable: true,
    compact: true,
    center: true,
    omit: true,
    hide: screens.LG,
    cell: (row: Row) =>
      CellData.ColoredDate({
        // date: row['Ult. Modificación'],
        date: '8/1/2022',
        isAdmin: row.isAdmin,
      }),
    export: true,
  },
  {
    sortable: false,
    cell: (row: Row) =>
      !row?.isDemo && (
        <ul
          className="nk-tb-actions gx-1"
          style={{
            zIndex: 999,
          }}
        >
          <li>
            <div className="dropdown">
              <MenuDots
                menuOptions={societyOptions(i18n)}
                // @ts-ignore
                id={row.society?._id || null}
                direction="left"
                params={{
                  societyName: row.society?.name,
                  user: row?.user,
                  mixpanel: row?.mixpanel,
                }}
              />
            </div>
          </li>
        </ul>
      ),
    export: false,
    right: true,
    width: '50px',
    allowOverflow: true,
  },
];

export default tableColumns;
